<style lang="less" scoped>
</style>

<template>
    <div>
        <input id="toTxc" v-show="false" type="button" value="新窗口打开" onclick="window.open('https://support.qq.com/products/135447?')"> 
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        methods: {
            init(){
                document.getElementById('toTxc').click();
            }
        },
        mounted() {
            this.init();
        }
    }
</script>